// extracted by mini-css-extract-plugin
export default {"startOld":"style_startOld__i8B8u","lineLabel":"style_lineLabel__ByjU6","picker":"style_picker__xNNWc"};